import { Unit21DataClassifier } from 'app/modules/dataSettings/responses';
import {
  OperandTypes,
  SymbolTable,
} from 'app/modules/rulesAdvanced/lib/SymbolTable';
import { ValueTypes } from 'app/modules/rulesAdvanced/models';

export const ACTION_EVENT_DROPDOWN_SYMBOLS: SymbolTable = Object.freeze({
  // NOTE: builderType === 'dropdown'
  txn_instrument_id: {
    type: OperandTypes.TEXT,
    text: 'Instrument ID',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'txn_instrument_id',
        label: 'txn_instrument_id',
        model: 'action_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.country': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / Country',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.country',
        label: 'geolocation.country',
        model: 'action_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.city': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / City',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.city',
        label: 'geolocation.city',
        model: 'action_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.postal_code': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / Postal code',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.postal_code',
        label: 'geolocation.postal_code',
        model: 'action_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.longitude': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / Longitude',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.longitude',
        label: 'geolocation.longitude',
        model: 'action_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  'geolocation.latitude': {
    type: OperandTypes.TEXT,
    text: 'Geolocation / Latitude',
    value: {
      operandType: OperandTypes.TEXT,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'geolocation.latitude',
        label: 'geolocation.latitude',
        model: 'action_event',
        datatype: 'string',
        cardinality: 'many',
      },
    },
  },
  ip_is_bot: {
    type: OperandTypes.TEXT,
    text: 'IP uses bot',
    value: {
      operandType: OperandTypes.BOOLEAN,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'ip_is_bot',
        label: 'ip_is_bot',
        model: 'action_event',
        datatype: 'boolean',
        cardinality: 'many',
      },
    },
  },
  ip_is_tor: {
    type: OperandTypes.TEXT,
    text: 'IP uses Tor',
    value: {
      operandType: OperandTypes.BOOLEAN,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'ip_is_tor',
        label: 'ip_is_tor',
        model: 'action_event',
        datatype: 'boolean',
        cardinality: 'many',
      },
    },
  },
  ip_is_vpn: {
    type: OperandTypes.TEXT,
    text: 'IP uses VPN',
    value: {
      operandType: OperandTypes.BOOLEAN,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'ip_is_vpn',
        label: 'ip_is_vpn',
        model: 'action_event',
        datatype: 'boolean',
        cardinality: 'many',
      },
    },
  },
  ip_is_proxy: {
    type: OperandTypes.TEXT,
    text: 'IP uses proxy',
    value: {
      operandType: OperandTypes.BOOLEAN,
      unit21DataClassifier: Unit21DataClassifier.ACTION_EVENT,
      value: {
        type: ValueTypes.FIELD,
        field: 'ip_is_proxy',
        label: 'ip_is_proxy',
        model: 'action_event',
        datatype: 'boolean',
        cardinality: 'many',
      },
    },
  },
});
